'use strict';

exports.__esModule = true;
var BIDS = exports.BIDS = {
  FETCH: 'FETCH_BIDS',
  SUCCESS: 'FETCH_SUCCESS_BIDS',
  FAIL: 'FETCH_FAIL_BIDS'
};

var SNAKE_BAR = exports.SNAKE_BAR = {
  HIDE_SNACK_BAR: 'HIDE_SNACK_BAR'
};

var PLACE_BID = exports.PLACE_BID = {
  SAVE: 'SAVE_PLACE_BID',
  SUCCESS: 'SAVE_PLACE_BID_SUCCESS',
  FAIL: 'SAVE_PLACE_BID_FAIL'
};

var TOGGLE_TUTORIAL_MODAL = exports.TOGGLE_TUTORIAL_MODAL = {
  TOGGLE: 'TOGGLE_TUTORIAL_MODAL'
};

var BID_INFO = exports.BID_INFO = {
  SET: 'SET_BID_INFO'
};

var fetchBids = exports.fetchBids = function fetchBids(payload) {
  return {
    type: BIDS.FETCH,
    payload: payload
  };
};

var fetchBidsSuccess = exports.fetchBidsSuccess = function fetchBidsSuccess(payload) {
  return {
    type: BIDS.SUCCESS,
    payload: payload
  };
};

var fetchBidsFail = exports.fetchBidsFail = function fetchBidsFail() {
  return {
    type: BIDS.FAIL
  };
};

var placeBid = exports.placeBid = function placeBid(payload) {
  return {
    type: PLACE_BID.SAVE,
    payload: payload
  };
};

var placeBidSuccess = exports.placeBidSuccess = function placeBidSuccess() {
  return {
    type: PLACE_BID.SUCCESS
  };
};

var placeBidFail = exports.placeBidFail = function placeBidFail() {
  return {
    type: PLACE_BID.FAIL
  };
};

var setBidInfo = exports.setBidInfo = function setBidInfo(payload) {
  return {
    type: BID_INFO.SET,
    payload: payload
  };
};

var toggleTutorialModal = exports.toggleTutorialModal = function toggleTutorialModal(payload) {
  return {
    type: TOGGLE_TUTORIAL_MODAL.TOGGLE,
    payload: payload
  };
};

var hideSnakBar = exports.hideSnakBar = function hideSnakBar() {
  return {
    type: SNAKE_BAR.HIDE_SNACK_BAR
  };
};